import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

//flatpickr
import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate';

//services
import { TranslateService } from '@ngx-translate/core';

//forms
import { GettingStartedForms } from './forms/lean-access-period.forms';
import { FlatpickrDefaultsInterface } from 'angularx-flatpickr';

@Component({
  selector: 'app-lean-access-period',
  templateUrl: './lean-access-period.component.html',
  styleUrls: ['./lean-access-period.component.scss'],
  standalone: false
})
export class LeanAccessPeriodComponent implements OnInit {

  @Output() leanConnectInitiated: EventEmitter<any> = new EventEmitter<{ accessFrom: any, accessTo: any }>();

  //flatpickr plugins
  plugins = [confirmDatePlugin({ confirmIcon: "" })];

  //The maximum access from selectable date to be (yesterday)
  flatpickrAccessFromOptions: FlatpickrDefaultsInterface = {
    maxDate: new Date(new Date().setDate(new Date().getDate() - 1))
  };

  //The minimum access to selectable date to be from Tomorrow's date && The maximum access to selectable date to be after one year (365 days)
  flatpickrAccessToOptions: FlatpickrDefaultsInterface = {
    minDate: new Date(new Date().setDate(new Date().getDate() + 1)),  // Set minDate to tomorrow
    maxDate: new Date(Date.now() + (365 * 24 * 60 * 60 * 1000)) // Adding 365 days to today's date
  };

  accessPeriodForm!: UntypedFormGroup;
  termsAndConditionsChecked: boolean = false;

  constructor(private _gettingStartedForms: GettingStartedForms, public _translate: TranslateService, private _offcanvasService: NgbOffcanvas,) { }

  ngOnInit(): void {

    //get Access Period Form
    this.accessPeriodForm =
      this._gettingStartedForms.getAccessPeriodFormForm();
  }

  // convenience getter for easy access to form fields
  get accessPeriod() {
    return this.accessPeriodForm.controls;
  }



  /**
   *  Close Opening Bank Modal Method
   */

  closeOpeningBank() {
    this._offcanvasService.dismiss();

  }

  connectBank() {
    let accessFrom = this.accessPeriodForm.get("accessFrom").value
    let accessTo = this.accessPeriodForm.get("accessTo").value
    this.leanConnectInitiated.emit({
      accessFrom: accessFrom,
      accessTo: accessTo
    });
  }

}
